<template>
  <div class="space-y-6">
    <!-- Date Range Filter -->
    <ReportsFilterBar
      :periods="periods"
      :selected-period="selectedPeriod"
      :custom-start-date="customStartDate"
      :custom-end-date="customEndDate"
      :view-mode="viewMode"
      @period-change="handlePeriodChange"
      @update:custom-start-date="customStartDate = $event"
      @update:custom-end-date="customEndDate = $event"
      @apply="applyCustomDateRange"
      @update:view-mode="viewMode = $event"
    />

    <!-- Loading State -->
    <LoadingSpinner
      v-if="loading"
      :text="tr('app.common.loading', 'Cargando...')"
    />

    <!-- Daily Summaries View -->
    <div
      v-if="dailyReports.length > 0"
      class="space-y-4"
    >
      <h3 class="text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-100">
        {{ tr('app.views.cashRegister.dailySummaries', 'Resúmenes diarios') }}
      </h3>

      <!-- Cards View -->
      <ReportsCardsView
        v-if="viewMode === 'cards'"
        :reports="dailyReports"
        @view-details="viewSessionDetails"
      />

      <!-- List View -->
      <ReportsListView
        v-else-if="viewMode === 'list'"
        :reports="dailyReports"
        @view-details="viewSessionDetails"
      />
    </div>

    <!-- No Data State -->
    <EmptyState
      v-else-if="!loading"
      :description="tr('app.views.cashRegister.noReportsFound', 'No se encontraron reportes para el periodo seleccionado.')"
    />
  </div>

  <!-- Session Details Modal -->
  <SessionDetailsModal
    :is-visible="sessionDetailsModalOpen"
    :session-id="selectedSessionId || undefined"
    @close="closeSessionDetailsModal"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useReports } from '@/composables/useReports'
import SessionDetailsModal from '@/components/SessionDetailsModal.vue'
import ReportsFilterBar from '@/components/reports/ReportsFilterBar.vue'
import ReportsCardsView from '@/components/reports/ReportsCardsView.vue'
import ReportsListView from '@/components/reports/ReportsListView.vue'
import EmptyState from '@/components/base/EmptyState.vue'
import LoadingSpinner from '@/components/base/LoadingSpinner.vue'

const { t, te } = useI18n()
const tr = (key: string, fallback: string) => (te(key) ? t(key) : fallback)

const {
  viewMode,
  selectedPeriod,
  customStartDate,
  customEndDate,
  loading,
  dailyReports,
  sessionDetailsModalOpen,
  selectedSessionId,
  periods,
  handlePeriodChange,
  applyCustomDateRange,
  viewSessionDetails,
  closeSessionDetailsModal
} = useReports()
</script>
